<template>
	<div class="cart-summary" v-if="order">
		<table class="table products-table">
			<tr class="table-head">
				<td>Descripción</td>
				<td class="text-right">Precio Unit</td>
				<td class="text-right">Cantidad</td>
				<td class="text-right">Subtotal</td>
			</tr>
			<tr v-for="(product, i) in order.products" :key="product.id">
				<td class="product-detail">
					<img v-if="product.product.image" :src="product.product.image.urlThumb" alt="" />
					<div class="ml-2">
						<h3>{{ product.product.name }}</h3>
						<p v-if="product.product.category">{{ product.product.category.title }}</p>
					</div>
				</td>
				<td class="text-right">
					<strong>U$S {{ product.priceUnit }}</strong>
				</td>
				<td class="text-right" v-if="editable">
					<div class="quantity">
						<div class="btn btn-secondary btn-qty" @click="qty('subtract', i)">-</div>
						{{ product.qty }}
						<div class="btn btn-secondary btn-qty" @click="qty('add', i)">+</div>
					</div>
				</td>
				<td class="text-right" v-if="!editable">
					<strong> {{ product.qty }}</strong>
				</td>
				<td class="text-right">
					<strong>U$S {{ product.priceSubtotal }}</strong>
				</td>
			</tr>
		</table>

		<!-- <div class="d-flex justify-content-end">
			<table class="table prices-table table-borderless">
				<tr>
					<td>Subtotal</td>
					<td>$ {{ order.priceSubtotal.toFixed(2) }}</td>
				</tr>
				<tr>
					<td>Impuestos</td>
					<td>$ {{ order.priceTaxes.toFixed(2) }}</td>
				</tr>
				<tr>
					<td><strong>TOTAL</strong></td>
					<td>
						<strong>U$S {{ order.priceTotal.toFixed(2) }}</strong>
					</td>
				</tr>
			</table>
		</div> -->
	</div>
</template>

<script>
export default {
	name: 'CarProductsTable',
	props: ['order', 'editable'],
	methods: {
		qty(action, index) {
			this.cartQuantity(action, index)
		},
	},
}
</script>

<style scoped>
.products-table tr {
}
.products-table tr.table-head td {
	height: 40px !important;
	border-bottom: 1px solid #dee2e6;
}

.products-table td,
.products-table tr:last-child {
	border: none;
}
.products-table td {
	vertical-align: middle;
	height: 72px !important;
}

.product-detail {
	display: flex;
	align-items: center;
}
.product-detail h3 {
	font-size: 15px;
	font-weight: 600;
}
.product-detail p {
	margin: 0px;
}
.product-detail img {
	max-width: 72px;
}

.prices-table {
}
.prices-table tr td {
	padding: 0.5rem;
}
.prices-table tr td:last-child {
	text-align: right;
}

.quantity {
	display: flex;
	align-items: center;
	justify-content: center;
}
.btn-qty {
	width: 36px;
	height: 36px;
	padding: 0px;
	display: flex;
	align-items: center;
	justify-content: center;
	margin: 0px 10px;
	border: none;
	background-color: #f3f3f3;
}

/*
.cart-section {
	opacity: 0.6;
}
.cart-section.active {
	opacity: 1;
}

div /deep/ .formulate-input .formulate-input-element {
	max-width: 100%;
	margin-bottom: 0.1em;
}

@media (max-width: 400px) {
	.product-detail img {
		display: none;
	}
}
*/
@media (min-width: 996px) {
	.prices-table {
		max-width: 300px;
	}
}
</style>
